/* istanbul ignore file */
import { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

const oidcConfig = {
    client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
    authority: process.env.REACT_APP_AUTH_AUTHORITY,
    redirect_uri: process.env.REACT_APP_AUTH_REDIRECT_URI,
    post_logout_redirect_uri: process.env.REACT_APP_AUTH_POST_LOGOUT_URL,
    includeIdTokenInSilentSignout: true,
    includeIdTokenInSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    response_type: 'code',
    scope: `openid profile email ${
        process.env.REACT_APP_AUTH_SCOPE ?? ''
    }`.trim(),
    onSigninCallback: () => {
        window.history.replaceState(
            {},
            document.title,
            window.location.pathname
        );
    },
} as AuthProviderProps;

export default oidcConfig;
